import { lazy } from "react";

import Spin from "core/ui-kit/spin";

import withSuspenseHoc from "core/HOCs/withSuspense";

import ROUTES from "core/constants/routes/routes";
import { PERMISSION_ACTION, PERMISSION_RESOURCE } from "core/constants/permission";
import { DIGITAIN_COMPANY_ID } from "core/constants/company";

const PermissionRequestsContainer = withSuspenseHoc(lazy(() => import("./permissionRequestsContainer")), <Spin />);

const PermissionRequestsPageRoute = {
    path: ROUTES.PERMISSION_REQUESTS,
    element: PermissionRequestsContainer,
    permission: [
        { resource: PERMISSION_RESOURCE.PERMISSION_REQUESTS, action: PERMISSION_ACTION.VIEW }
    ],
    isDisabled: ( projectId, user ) => user.companyId !== DIGITAIN_COMPANY_ID
};

export default PermissionRequestsPageRoute;
